import { __assign, __makeTemplateObject } from "tslib";
import React from 'react';
import { ArrowDown } from '@ringcentral/juno-icon';
import { styled } from '../../../../foundation';
import { RcIcon } from '../../../Icon';
var _StyledArrowIcon = function (props) { return (React.createElement(RcIcon, __assign({ symbol: ArrowDown, size: "medium" }, props))); };
export var StyledArrowIcon = styled(_StyledArrowIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  transform: ", ";\n\n  &&& {\n    color: inherit;\n    margin-right: 0;\n  }\n"], ["\n  transform: ", ";\n\n  &&& {\n    color: inherit;\n    margin-right: 0;\n  }\n"])), function (_a) {
    var open = _a.open;
    return open && 'rotate(180deg)';
});
var templateObject_1;
